import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=1a37f6ee&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=1a37f6ee&prod&lang=stylus&scoped=true"
import style1 from "./GoodsInfo.vue?vue&type=style&index=1&id=1a37f6ee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37f6ee",
  null
  
)

export default component.exports